module.exports = __webpack_public_path__ + "static/media/landscape5.008a628f.jpg";